export const GET_PAYOUT = "GET_PAYOUT";

export const ACCEPT_PAYOUT = "ACCEPT_PAYOUT";

export const DECLINE_PAYOUT = "DECLINE_PAYOUT";
export const OPEN_DECLINE_DIALOG = "OPEN_DECLINE_DIALOG";
export const CLOSE_DECLINE_DIALOG = "CLOSE_DECLINE_DIALOG";